import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import bbox from '@turf/bbox';
import { useCallback, useRef, useState } from 'react';
import Map from 'react-map-gl';
import PreviewButton, { monoStyle } from '../../../helpers/PreviewButton';
import DrawControl from '../../../helpers/maps/DrawControl';

const BlockMapEditable = ({ geom, onChange }) => {
  const [mapStyle, setMapStyle] = useState(monoStyle);
  const [initialBoundsSet, setInitialBoundsSet] = useState(false);
  const mapRef = useRef();

  const initialViewPort = {
    latitude: -41,
    longitude: 174.5,
    zoom: 4,
    height: 300,
    width: '100%'
  };

  const [viewport, setViewport] = useState(initialViewPort);

  const fitBounds = useCallback(
    (map) => {
      if (geom) {
        const [minLng, minLat, maxLng, maxLat] = bbox(geom);
        map.fitBounds(
          [
            [minLng, minLat],
            [maxLng, maxLat]
          ],
          { padding: 50, duration: 500 }
        );
      }
    },
    [geom]
  );

  const onMapLoad = useCallback(
    (e) => {
      const map = e.target;
      mapRef.current = map;

      if (geom && !initialBoundsSet) {
        fitBounds(map);
        setInitialBoundsSet(true);
      }
    },
    [geom, onChange, fitBounds, initialBoundsSet]
  );

  const onUpdate = useCallback((e) => {
    onChange(e.features[0].geometry);
  }, []);

  const onDelete = useCallback(() => {
    onChange(null);
  }, []);

  return (
    <Map
      style={{ width: '100%', height: '100%' }}
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
      mapStyle={`${mapStyle}`}
      initialViewState={viewport}
      onViewportChange={(next) => setViewport(next)}
      attributionControl={false}
      onLoad={onMapLoad}
    >
      <DrawControl
        initialBoundry={
          geom ? { type: 'Feature', geometry: geom, properties: {} } : null
        }
        position='top-right'
        displayControlsDefault={false}
        controls={{
          polygon: true,
          trash: true
        }}
        defaultMode={geom ? 'simple_select' : 'draw_polygon'}
        onCreate={onUpdate}
        onUpdate={onUpdate}
        onDelete={onDelete}
      />
      <PreviewButton
        setMapStyle={setMapStyle}
        mapStyle={mapStyle}
        viewport={viewport}
      />
    </Map>
  );
};

export default BlockMapEditable;

